"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const design_system_patterns_1 = require("@zapier/design-system-patterns");
const design_system_1 = require("@zapier/design-system");
const core_1 = require("@emotion/core");
const AppListItemLabel_1 = __importDefault(require("./AppListItemLabel"));
const appListItemBaseCss = core_1.css `
  padding: 10px;
  font-size: 0.875em;
  display: flex;
  align-items: center;
  border-radius: 10px;
  font-weight: 600;

  transition: all 0.15s ease-in-out;
  border: solid transparent 1px;
`;
const appListItemCss = (isDisabled) => isDisabled
    ? core_1.css `
        opacity: 0.6;
        cursor: not-allowed;
      `
    : core_1.css `
        /* Enable the focus-specific pseudo element to be properly positioned */
        position: relative;

        transition-property: all;
        transition-timing-function: ${design_system_1.Animation.transitionTimingFunction};
        transition-duration: ${design_system_1.Animation.transitionDuration};

        &:hover,
        &:focus {
          border: solid ${design_system_1.Colors.grey200} 1px;
          box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
          background-color: #fff;
          border-radius: 10px;
          cursor: pointer;

          *[class$='name'] {
            color: ${design_system_1.Colors.blue500};
          }
        }

        /* Focus-specific pseudo-element to match ZDS focus outlines */
        &::before {
          content: '';
          position: absolute;
          pointer-events: none;
          top: 2px;
          right: 2px;
          bottom: 2px;
          left: 2px;
          border: 2px solid transparent;
          border-radius: 10px;
          transition-property: all;
          transition-timing-function: ${design_system_1.Animation.transitionTimingFunction};
          transition-duration: ${design_system_1.Animation.transitionDuration};
        }
        &:focus {
          &::before {
            border-color: ${design_system_1.Colors.blue500};
            top: -1px;
            right: -1px;
            bottom: -1px;
            left: -1px;
          }
        }
      `;
const appListItemLogoCss = core_1.css `
  margin-right: 10px;
`;
function AppListItem({ app, onSelect, isSearching, }) {
    const { name, subtitle, banner, iconUrl, isDisabled, key } = app;
    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            onSelect(key);
        }
    };
    const onClick = react_1.useCallback(() => onSelect(key), [onSelect, key]);
    const appListItemProps = isDisabled
        ? {}
        : {
            role: 'button',
            tabIndex: 0,
            onClick,
            onKeyDown,
        };
    return (core_1.jsx("div", Object.assign({ css: [appListItemBaseCss, appListItemCss(isDisabled)] }, appListItemProps),
        core_1.jsx("div", { css: appListItemLogoCss },
            core_1.jsx(design_system_patterns_1.ServiceIcon, { lazyloadOffset: null, serviceName: name, size: 30, src: iconUrl })),
        core_1.jsx(AppListItemLabel_1.default, { banner: banner, isSearching: isSearching, name: name, subtitle: subtitle })));
}
exports.default = AppListItem;
